export const ACTIONS_ALIEXPRESS = {
  ADD_PRODUCTS: 'ADD_ALIEXPRESS_PRODUCTS',
  CHANGE_PRODUCT: 'CHANGE_ALIEXPRESS_PRODUCT',
  CHANGE_MARKET: 'CHANGE_ALIEXPRESS_MARKET',
};

export const addAliexpressProducts = data => ({
  type: ACTIONS_ALIEXPRESS.ADD_PRODUCTS,
  data,
});

export const actionChangeAliexpressProduct = (product = {}) => ({
  type: ACTIONS_ALIEXPRESS.CHANGE_PRODUCT,
  product,
});

export const changeAliexpressMarket = market => ({
  type: ACTIONS_ALIEXPRESS.CHANGE_MARKET,
  market,
});